import { EtabAdminFolderModel, IEtabAdminFolder } from "@core/models";

export class EtabAdminFolderDTO extends EtabAdminFolderModel {
  prepareUpdateData() {
    return {
      social_reason: this[IEtabAdminFolder.socialReason],
      siret: this[IEtabAdminFolder.siret],
      vat_number: this[IEtabAdminFolder.vat],
      email: this[IEtabAdminFolder.email],
      address: this[IEtabAdminFolder.address],
      city: this[IEtabAdminFolder.city],
      zipcode: this[IEtabAdminFolder.postalCode],
      country: this[IEtabAdminFolder.country],
    };
  }
}
